import {useState} from 'react';

export default () => {
    const [active_question, setActiveQuestion] = useState(null);

    return (
        <div className="faq">
            <div className="title">FAQ</div>

            <div className="faq-items">
                <div className={`faq-item  ${active_question === 'hiw' ? 'active' : ''}`} onClick={e => setActiveQuestion('hiw' === active_question ? null : 'hiw')}>
                    <div className="faq-question">
                        <span>How it works?</span>

                        <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.71074 8.94998L11.9447 15.47C12.799 16.24 14.1969 16.24 15.0512 15.47L22.2852 8.94999" stroke="#30344F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="faq-answer">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum
                    </div>
                </div>

                <div className={`faq-item  ${active_question === 'hiw2' ? 'active' : ''}`} onClick={e => setActiveQuestion('hiw2' === active_question ? null : 'hiw2')}>
                    <div className="faq-question">
                        <span>How to pay with Cash Card?</span>

                        <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.71074 8.94998L11.9447 15.47C12.799 16.24 14.1969 16.24 15.0512 15.47L22.2852 8.94999" stroke="#30344F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="faq-answer">
                        A deposit with a CashApp Card is made in the same way as a deposit with any other card.<br/>
                        <br/>
                        1. Specify the deposit amount and Email address for receipt of the check<br/>
                        2. Go to the payment page.<br/>
                        3. Fill in the required information.
                    </div>
                </div>
            </div>
        </div> 
    )
}